const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === "object" && value !== null && !Array.isArray(value);

const readPositiveNumber = (value: unknown) =>
  typeof value === "number" && Number.isFinite(value) && value > 0 ? value : undefined;

export const parseBuildingAreas = (payload: unknown) => {
  if (!isRecord(payload)) return { grossArea: undefined, netLettableArea: undefined };
  return {
    grossArea: readPositiveNumber(payload.gross_asset_basement_included),
    netLettableArea: readPositiveNumber(payload.net_lettable_area_without_basement),
  };
};
